var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNovapointRailwaySvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "xaml",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#363545;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NovapointRailway_svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32,23H29.59l-1.86-4H30V17H26.79l-1.86-4H28V11H24L22.13,7H25V5H21.2l-.93-2H11.73L10.8,5H7V7H9.87L8,11H4v2H7.07L5.21,17H2v2H4.27L2.41,23H0v2H1.48L0,28.17V29H4l1.87-4H26.11L28,29h4v-.83L30.52,25H32ZM16,3.32,16.78,5H15.22ZM14.28,7h3.44l1.86,4H12.42Zm-2.79,6h9l1.87,4H9.62ZM6.82,23l1.87-4H23.31l1.87,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovapointRailwaySvg);
export default __webpack_public_path__ + "static/media/NovapointRailway_svg.7b48165a56ff0486b74d56b82c45d7f5.svg";
export { ForwardRef as ReactComponent };